var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenseMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "admin_panel_settings_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6545",
    "data-name": "Group 6545"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1500",
    "data-name": "Rectangle 1500",
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6547",
    "data-name": "Group 6547",
    transform: "translate(1.956 1.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6546",
    "data-name": "Group 6546"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 1.095,
    cy: 1.095,
    r: 1.095,
    transform: "translate(12.596 11.129)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M16.951,17.5c-.714,0-2.142.352-2.191,1.056a2.669,2.669,0,0,0,4.381,0C19.092,17.852,17.665,17.5,16.951,17.5Z",
    transform: "translate(-3.259 -3.32)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M17.669,10.912V6.2L10.335,3,3,6.2V11a9.988,9.988,0,0,0,7.335,9.6,8.964,8.964,0,0,0,1.565-.538,5.863,5.863,0,1,0,5.77-9.154Zm-6.846,5.78a5.639,5.639,0,0,0,.225,1.584,6.442,6.442,0,0,1-.714.293A8.027,8.027,0,0,1,4.956,11V7.479l5.379-2.347,5.379,2.347v3.433A5.865,5.865,0,0,0,10.824,16.691ZM16.691,20.6A3.912,3.912,0,1,1,20.6,16.691,3.911,3.911,0,0,1,16.691,20.6Z",
    transform: "translate(-3 -3)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseMenu);
export default __webpack_public_path__ + "static/media/license_menu.e559ea15b8891670a1749ede72dbe166.svg";
export { ForwardRef as ReactComponent };